<template>
	<v-container fluid>
		<v-layout mb-3>
			<h3>Limity finansowania poszczególnych krajów</h3>

		</v-layout>
		<v-layout row wrap ml-3>
			<v-flex xs6 mb-4 v-for="(property) in localProperties" :key="property.id">
				<v-flex mb-3>
					<h4>{{property.countryName}}</h4>
				</v-flex>
				<v-flex xs6>
					<egranty-number-input-field
						label="Minimalna kwota dofinansowania"
						for="financial-limits-per-country-min-funding"
						id="financial-limits-per-country-min-funding"
						v-model="property.minFunding"
						suffix=" PLN"
						placeholder="np. 25000"
					></egranty-number-input-field>
				</v-flex>
				<v-flex xs6>
					<egranty-number-input-field
						label="Maksymalna kwota dofinansowania"
						for="financial-limits-per-country-max-funding"
						id="financial-limits-per-country-max-funding"
						v-model="property.maxFunding"
						suffix=" PLN"
						placeholder="np. 100000"
					></egranty-number-input-field>
				</v-flex>
			</v-flex>
		</v-layout>
	</v-container>
</template>

<script>
	import EgrantyNumberInputField from "../../../../genericComponents/EgrantyNumberInputField";
	import {FinancialSettings} from "../../../../api/generated/FinancialSettings";

	export default {
		name: "FinancialLimitsPerCountry",
		components: {EgrantyNumberInputField},
		props: {
			moduleNumber: {type: Number, default: null}
		},
		computed: {
			contestId() {
				return this.$route.params.id;
			},
		},

		methods: {
			refresh() {
				FinancialSettings.getFinancialLimitsPossibilities(
					this,
					this.contestId,
					false,
					this.moduleNumber ? this.moduleNumber : "",
					response => {
						this.properties = response.filter(x=>!x.legalForm);
						this.localProperties = this.nullifyProperties(this.properties);
					},
				);
			},

			getValuesToSave(){
				return this.localProperties;
			},

			nullifyProperties(properties) {
				return properties.map(property => {
					let minFunding = null, maxFunding = null;
					if (property.minFunding !== null) {
						minFunding = property.minFunding;
					}
					if (property.maxFunding !== null) {
						maxFunding = property.maxFunding;
					}
					return {
						countryId: property.countryId,
						countryName: property.countryName,
						maxFunding: maxFunding,
						minFunding: minFunding,
					};
				});
			},

			denullifyProperties(properties) {
				return properties.map(property => {
					let minFunding = null, maxFunding = null;
					if (property.minFunding !== null && property.minFunding !== "") {
						minFunding = property.minFunding;
					}
					if (property.maxFunding !== null && property.maxFunding !== "") {
						maxFunding = property.maxFunding;
					}
					return {
						countryId: property.countryId,
						countryName: property.countryName,
						maxFunding: maxFunding,
						minFunding: minFunding,
					};
				});
			},

			validate() {
				let errorMessages = [];
				for (let property of this.localProperties) {
					if(property.maxFunding == null || property.maxFunding==0){
						if(this.moduleNumber == null || this.moduleNumber ==0){
							errorMessages.push("Maksymalna kwota dofinansowania nie może być równa 0 dla kraju " + property.countryName + ".");
						} else {
							errorMessages.push("Maksymalna kwota dofinansowania nie może być równa 0 dla kraju " + property.countryName + " w module " + this.moduleNumber + " .");
						}
					} else if(property.maxFunding !== null && (parseFloat(property.minFunding) > parseFloat(property.maxFunding))){
						if(this.moduleNumber == null || this.moduleNumber ==0){
							errorMessages.push("Minimalna kwota dofinansowania nie może być większa od maksymalnej dla kraju " + property.countryName + ".");
						} else {
							errorMessages.push("Minimalna kwota dofinansowania nie może być większa od maksymalnej dla kraju " + property.countryName + " w module " + this.moduleNumber + " .");
						}
					}
					else if(property.minFunding === ""){
						if(this.moduleNumber == null || this.moduleNumber ==0){
							errorMessages.push("Minimalna kwota dofinansowania musi być uzupełniona dla kraju " + property.countryName + ".");
						} else {
							errorMessages.push("Minimalna kwota dofinansowania musi być uzupełniona dla kraju " + property.countryName + " w module " + this.moduleNumber + " .");
						}
					} else if((parseFloat(property.minFunding) == parseFloat(property.maxFunding))){
						if(this.moduleNumber == null || this.moduleNumber ==0){
							errorMessages.push("Minimalna i maksymalna kwota dofinansowania nie mogą być równe dla kraju " + property.countryName + ".");
						} else {
							errorMessages.push("Minimalna i maksymalna kwota dofinansowania nie mogą być równe dla kraju " + property.countryName + " w module " + this.moduleNumber + " .");
						}
					}
				}
				if (errorMessages.length > 0) {
					this.$emit("error", errorMessages);
					return false;
				}
				return true;
			},
		},

		mounted() {
			this.refresh();
		},

		data() {
			return {
				properties: [],
				localProperties: [],
			};
		},

	};
</script>

<style scoped>

</style>
